import React from 'react';

import { Card } from '@tmap/mmm-style-guide/src/Card';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const ColoredBg = styled('div')(({ theme }) => ({
  width: '100%',
  height: '328px',
  backgroundColor: theme.palette.primary.main,
}));

const BodyWrapper = styled(Card)(({ theme }) => ({
  position: 'relative',
  marginLeft: '100px',
  marginRight: '100px',
  marginTop: '-210px',
  marginBottom: theme.spacing(10),
  padding: theme.spacing(5),
  borderRadius: '16px',
  boxShadow: '0px 8px 42px 7px #0000001F',
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
}));

function BigCard(props) {
  const {
    children,
  } = props;

  return (
    <>

      <ColoredBg />
      <BodyWrapper>
        {children}
      </BodyWrapper>
    </>
  );
}

export default BigCard;
